import { render, staticRenderFns } from "./MatchPairsSelectAnswer.vue?vue&type=template&id=3f21704c&scoped=true&"
import script from "./MatchPairsSelectAnswer.vue?vue&type=script&lang=js&"
export * from "./MatchPairsSelectAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MatchPairsSelectAnswer.vue?vue&type=style&index=0&id=3f21704c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f21704c",
  null
  
)

export default component.exports